import type { FC } from "react"
import { useMemo } from "react"
import { TagCategorySlider } from "@/components/Tags/TagCategorySlider"
import { useAppSelector } from "@/hooks/redux"
import { TagType } from "@/types"

const MULTI_LEVEL = 2
const COND_FOR_MULTI_LEVEL = 6

export const TagsCategories: FC = () => {
  const { currentCategory, breadcrumbs } = useAppSelector(
    (state) => state.catalog,
  )

  // категории, отображающиеся вместе с тегами
  // если вложенных категорий нет - берем смежные - на одном уровне с текущей
  const relatedCategories: TagType[] = useMemo(() => {
    if (!breadcrumbs || !currentCategory?.uuid) {
      return []
    }
    let sub = breadcrumbs[currentCategory.uuid]?.subItems || []

    if (!sub.length) {
      const breadcrumbsArr = Object.entries(breadcrumbs)
      const foundedPrevBreadcrumb =
        breadcrumbsArr[
          breadcrumbsArr.findIndex(([uuid]) => uuid === currentCategory.uuid) -
            1
        ]

      sub = !foundedPrevBreadcrumb
        ? []
        : foundedPrevBreadcrumb[1]?.subItems || []
    }

    return sub.map(({ title, path, id, image, qty }) => ({
      name: title,
      url: path,
      id: id,
      image: image,
      qty,
    })) as TagType[]
  }, [breadcrumbs, currentCategory?.uuid])

  const tags = useMemo(
    () =>
      relatedCategories
        .filter(({ id, qty }) => {
          const isNotCurrent = !!id && `${id}` !== currentCategory?.uuid
          const isNotNull = qty !== undefined ? qty > 0 : true
          return isNotCurrent && isNotNull
        })
        .sort(({ name: nA = "" }, { name: nB = "" }) => {
          const nameA = nA.toLowerCase()
          const nameB = nB.toLowerCase()
          return nameA > nameB ? 1 : nameA < nameB ? -1 : 0
        }),
    [relatedCategories, currentCategory?.uuid],
  )

  if (!(tags || []).length) {
    return null
  }

  return (
    <TagCategorySlider
      tags={tags}
      multilevel={tags.length > COND_FOR_MULTI_LEVEL ? MULTI_LEVEL : undefined}
      isOutside
      tagKey={"id"}
    />
  )
}

TagsCategories.displayName = "TagsCategories"
